import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core'

import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { ScopeElementsService } from '../services/scope-elements.service'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'
import { getCrFieldToDisplay, getCrNetChanges, showCrDifferences, showCrNetChanges } from '../utils/change-request'
import { DepartmentWithChanges } from '../models/entities-with-changes/department-with-changes.interface'
import { FormatHoursPipe, formatHoursPipeFn } from '@app/shared/pipe/formatHours.pipe'
import { ConvertCurrencyPipe } from '@app/shared/pipe/convertCurrency.pipe'
import { DEFAULT_PLACEHOLDER } from '@app/shared/constants/default-placeholder.const'
import { Money } from '@app/features/scope-overview/model/money.model'
import { formatCrPrice } from '../utils/format-value.utils'

@Component({
  selector: 'scope-departments-row',
  templateUrl: './departments-row.component.html',
  providers: [FormatHoursPipe],
})
export class DepartmentsRowComponent {
  @Input() level: number
  @Input() component: ScopeComponent
  @Input() config: ScopeElementsConfig
  @Input() department: DepartmentWithChanges

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  constructor(
    protected scopeElementsService: ScopeElementsService,
    private convertCurrencyPipe: ConvertCurrencyPipe
  ) {}

  selectDepartment(departmentId: number) {
    this.scopeElementsService.toggleDepartment(departmentId)
  }

  getFieldToDisplay = (fieldName: string) => getCrFieldToDisplay<DepartmentWithChanges>(fieldName, this.department)
  showDiff = (fieldName: string): boolean =>
    showCrDifferences<DepartmentWithChanges>(this.config, this.department, fieldName)

  formatPrice = (value: number | Money): string => formatCrPrice(value, this.config?.currency, this.convertCurrencyPipe)
  protected readonly formatHours = formatHoursPipeFn

  showNetChanges = (fieldName: string) =>
    showCrNetChanges(this.config, this.isElementAdded || this.isElementRemoved, this.department.changes?.[fieldName])
  getNetChanges = (fieldName: string, defaultValue: number) =>
    getCrNetChanges(this.department.changes, fieldName, defaultValue, this.isElementAdded, this.isElementRemoved)

  @HostBinding('class.change-request-removed') get isElementRemoved() {
    return (
      this.config?.isChangeRequest && (this.config?.showDiff || this.config?.showNetDelta) && this.department.isRemoved
    )
  }

  @HostBinding('class.change-request-added') get isElementAdded() {
    return (
      this.config?.isChangeRequest &&
      (this.config?.showDiff || this.config?.showNetDelta) &&
      (this.department.isAdded || !this.department.id)
    )
  }

  protected readonly isPreferenceActive = isPreferenceActive
  protected readonly DEFAULT_PLACEHOLDER = DEFAULT_PLACEHOLDER
  protected readonly Privilege = Privilege
}
